/* eslint-disable camelcase */
let categories = {
  title: 'Categorias',
  title_s: 'Categoria',
  title_: 'Categorias de',
  icon: 'mdi-format-list-bulleted',
  new: {
    title: 'Nova Categoria',
    no_cat: 'Sem Categoria',
    no_one: 'Nenhuma',
    name: 'Título',
    parent: 'Categoria ascendente',
    no_parent: 'Nenhuma',
    all: 'Todas',
    all_cat: 'Todas Categorias',
    clear: 'Limpar',
    save: 'Salvar',
    close: 'Fechar',
    rules: {
      nameRules: [
        v => !!v || 'Título é obrigatório',
        v => (v && v.length <= 27) || 'O Título deve ter menos que 27 caracteres'
      ]
    }
  },
  edit: {
    title: 'Editar Categoria',
    parentAlert: '* Não é permitido "Categoria ascendente" em Categorias que contém Sub-Categorias'
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir a Categoria',
    hasChildren: function (name) {
      return `A Categoria '${name}' contém outras Sub-Categorias, o que deseja fazer ?`
    }
  },
  messages: {
    error: {
      not_found: 'Categoria não encontrada'
    }
  }
}

export default categories
